import { Component } from '@angular/core';

@Component({
	selector: 'notifications-not-found',
	templateUrl: './notifications-not-found.component.html',
})
export class NotificationsNotFoundComponent {}
